import { Link } from 'gatsby'
import React from 'react'

export const BtnOutline = ({btnText, link}) => {
  return (
    <Link to={link} target="_blank">
    <button type="button" className="btn btn-outline-primary">{btnText}</button>
    </Link>
  )
}
